import React from 'react';
import { connect } from 'react-redux';
import ListItem from 'components/ListItem';
import { createStructuredSelector } from 'reselect';
import { AppState } from 'services/types';
import {
    CalibrationId,
    CalibrationEngineRpm
} from 'services/equipmentSets/types';
import { makeSelectCalibrationEngineRpm } from 'services/equipmentSets/selectors';
import { SprayEquipmentSetId } from 'services/sprayEvents/types';

export interface OwnProps {
    calibrationId: CalibrationId;
    equipmentSetId: SprayEquipmentSetId;
}

export interface ConnectedProps {
    engineRpm: CalibrationEngineRpm;
}

type Props = OwnProps & ConnectedProps;

export class SummaryCalibrationsEngineRpmListItemComponent extends React.PureComponent<
    Props
> {
    render(): React.ReactElement {
        const { engineRpm } = this.props;

        return <ListItem description="Engine RPM" value={`${engineRpm} RPM`} />;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    engineRpm: makeSelectCalibrationEngineRpm()
});

export default connect(mapStateToProps)(
    SummaryCalibrationsEngineRpmListItemComponent
);
